// Tech Aesthesis — homepage interactions

document.addEventListener('DOMContentLoaded', function () {

  // Mobile menu toggle
  var menuToggle = document.querySelector('.menu-toggle');
  var navLinks = document.querySelector('.nav-links');
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', function () {
      navLinks.classList.toggle('nav-links--open');
    });
  }

  // Sticky "Add to Cart" bar: only show after hero has scrolled out of view
  var stickyCta = document.querySelector('.sticky-cta');
  var hero = document.querySelector('.hero');
  if (stickyCta && hero) {
    stickyCta.style.transform = 'translateY(100%)';
    stickyCta.style.transition = 'transform .25s ease';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyCta.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  // Header hide-on-scroll-down / show-on-scroll-up (mobile pattern)
  var header = document.querySelector('header');
  var lastScroll = 0;
  window.addEventListener('scroll', function () {
    var current = window.scrollY;
    if (header) {
      if (current > lastScroll && current > 120) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
      header.style.transition = 'transform .25s ease';
    }
    lastScroll = current;
  });

  // Newsletter popup — appears once, after 50% scroll depth or 20s, whichever first
  var shown = false;
  function maybeShowPopup() {
    if (shown) return;
    shown = true;
    console.log('Newsletter popup would trigger here (hook up your popup/app of choice).');
  }
  window.addEventListener('scroll', function () {
    var scrollPercent = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
    if (scrollPercent > 0.5) maybeShowPopup();
  });
  setTimeout(maybeShowPopup, 20000);

});
